import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertDialogData, AlertDialogType } from '@core/utils/dialog-utils';

@Component({
  selector: 'kmt-alert-dialog',
  templateUrl: './alert-dialog.component.html'
})
export class AlertDialogComponent implements OnInit {
  AlertTypes = AlertDialogType;
  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public alert: AlertDialogData
  ) {}

  ngOnInit() {}
}
